/* eslint-disable comma-dangle */

export default {
  address: ['user-input', 'map', 'underground'],
  'about-object': ['common/cadastral-number', 'garage-type', 'total-area-garage', 'garage-status'],
  'about-building': ['gsk', 'parking', 'technical-details'],
  'price-and-deal-terms': [
    'price-rent',
    'garage-included-options',
    'min-lease-term',
    'security-deposit',
    'prepay-type',
    'fee-client',
  ],
};
